// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import FeedbackElement from "./feedback-element.js"
import FeedbackSurvey from "./feedback-survey.js"
import Step from "./step.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "unfinished",
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "FeedbackStep",
  "collectionKey": "feedback_steps",
  "collectionName": "feedback_steps",
  "i18nKey": "feedback_step",
  "camelizedLower": "feedbackStep",
  "name": "FeedbackStep",
  "nameDasherized": "feedback-step",
  "pluralName": "feedback_steps",
  "ransackable_associations": [
    {
      "className": "FeedbackAssignment",
      "collectionName": "feedback_assignments",
      "foreignKey": "feedback_assignment_id",
      "name": "feedback_assignment",
      "macro": "has_one",
      "resource_name": "FeedbackAssignment",
      "through": "feedback_survey"
    },
    {
      "className": "FeedbackElement",
      "collectionName": "feedback_elements",
      "foreignKey": "feedback_step_id",
      "name": "feedback_elements",
      "macro": "has_many",
      "resource_name": "FeedbackElement",
      "through": null
    },
    {
      "className": "FeedbackSurvey",
      "collectionName": "feedback_surveys",
      "foreignKey": "feedback_survey_id",
      "name": "feedback_survey",
      "macro": "belongs_to",
      "resource_name": "FeedbackSurvey",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "owners",
      "macro": "has_many",
      "resource_name": "User",
      "through": "feedback_assignment"
    },
    {
      "className": "Step",
      "collectionName": "steps",
      "foreignKey": "step_id",
      "name": "step",
      "macro": "belongs_to",
      "resource_name": "Step",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "team_survey_to_feedback_id",
      "name": "team_survey_to_feedback",
      "macro": "has_one",
      "resource_name": "TeamSurvey",
      "through": "feedback_survey"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "users",
      "macro": "has_many",
      "resource_name": "User",
      "through": "feedback_assignment"
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "feedback_survey_id",
      "column": {
        "default": null,
        "name": "feedback_survey_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_feedback_survey_id",
      "column": {
        "default": null,
        "name": "old_feedback_survey_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_step_id",
      "column": {
        "default": null,
        "name": "old_step_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "state",
      "column": {
        "default": "unfinished",
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "step_id",
      "column": {
        "default": null,
        "name": "step_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "FeedbackElement",
      "collectionName": "feedback_elements",
      "foreignKey": "feedback_step_id",
      "name": "feedback_elements",
      "macro": "has_many",
      "resource_name": "FeedbackElement",
      "through": null
    },
    {
      "className": "FeedbackSurvey",
      "collectionName": "feedback_surveys",
      "foreignKey": "feedback_survey_id",
      "name": "feedback_survey",
      "macro": "belongs_to",
      "resource_name": "FeedbackSurvey",
      "through": null
    },
    {
      "className": "Step",
      "collectionName": "steps",
      "foreignKey": "step_id",
      "name": "step",
      "macro": "belongs_to",
      "resource_name": "Step",
      "through": null
    }
  ],
  "paramKey": "feedback_step",
  "primaryKey": "id"
}

/** Frontend model for FeedbackStep. */
export default class FeedbackStep extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./feedback-element.js").default>} */
  feedbackElements() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["feedback_step_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "feedback_elements",
        model: this,
        modelClass: FeedbackElement
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./feedback-element.js").default>>} */
  loadFeedbackElements() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["feedback_step_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "feedback_elements",
        model: this,
        modelClass: FeedbackElement
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./feedback-element.js").default>>} */
  ensureFeedbackElementsLoaded() {
    return this.ensureAssociationLoaded("feedback_elements")
  }

  /** @returns {import("./feedback-survey.js").default | null} */
  feedbackSurvey() {
    return this._readBelongsToReflection({modelClass: FeedbackSurvey, reflectionName: "feedback_survey"})
  }

  /** @returns {Promise<import("./feedback-survey.js").default | null>} */
  loadFeedbackSurvey() {
    if (!("feedbackSurveyId" in this)) throw new Error("Foreign key method wasn't defined: feedbackSurveyId")

    const id = this.feedbackSurveyId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "feedback_survey",
        model: this,
        modelClass: FeedbackSurvey
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./feedback-survey.js").default | null>} */
  ensureFeedbackSurveyLoaded() {
    return this.ensureAssociationLoaded("feedback_survey")
  }

  /** @returns {import("./step.js").default | null} */
  step() {
    return this._readBelongsToReflection({modelClass: Step, reflectionName: "step"})
  }

  /** @returns {Promise<import("./step.js").default | null>} */
  loadStep() {
    if (!("stepId" in this)) throw new Error("Foreign key method wasn't defined: stepId")

    const id = this.stepId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "step",
        model: this,
        modelClass: Step
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./step.js").default | null>} */
  ensureStepLoaded() {
    return this.ensureAssociationLoaded("step")
  }
}
